import { ns } from '../global/namespace.js';

export const DISCLOSE_EVENT = ns.event('DISCLOSE');
export const CONCEAL_EVENT = ns.event('CONCEAL');
